/**
 * Centralized env-var reader. Vite exposes only `VITE_`-prefixed vars to the
 * client. Defaults match the legacy admin's hardcoded production URLs so
 * v2 works out of the box without a .env in deployment scenarios that
 * inherit the same hosting.
 */
const fromEnv = (key: string, fallback: string): string => {
  const v = (import.meta as ImportMeta & { env: Record<string, string | undefined> })
    .env[key]
  return v && v.length > 0 ? v : fallback
}

export const ENV = {
  API_BASE_URL: fromEnv("VITE_API_BASE_URL", "https://api.goodtalk.coach"),
  UPLOAD_BASE_URL: fromEnv(
    "VITE_UPLOAD_BASE_URL",
    "https://upload.goodtalk.coach"
  ),
} as const
